module.exports = __webpack_public_path__ + "img/weissrotgespritzt.0281f6f3.jpg";